module.exports = __webpack_public_path__ + "static/96249587-d04f7deba397966d4113d425de2342f9.jpg";